<template>
  <div class="commercial-list-actions">
    <former-button
      size="small"
      icon="pen"
      class="commercial-list-action"
      @click="change"
    >
      Editar regra
    </former-button>

    <former-button
      v-if="!rule.main"
      size="small"
      color="gray"
      class="commercial-list-action"
      icon="trash"
      @click="togglePopup"
    >
      Remover
    </former-button>

    <popup-confirm
      v-if="showPopup"
      :loading="loading"
      color="red"
      title="Remover regra"
      @close="togglePopup"
      @confirm="destroy"
    >
      Você tem certeza?
    </popup-confirm>
  </div>
</template>

<script>
  import FormerButton from '@/components/Former/Button.vue';
  import PopupConfirm from '@/components/Popup/Confirm.vue';

  export default {
    name: 'CommercialListItem',
    components: {
      FormerButton,
      PopupConfirm,
    },
    props: {
      loading: {
        type: Boolean,
        default: false,
      },
      deleteAction: {
        type: String,
        default: '',
      },
      updateAction: {
        type: String,
        default: '',
      },
      rule: {
        type: Object,
        default() {
          return {};
        },
      },
    },
    data() {
      return {
        showPopup: false,
        subtitle: this.rule.bank || this.rule.vehicle_model ? 'Definições Complementares' : '',
      };
    },
    methods: {
      togglePopup() {
        this.showPopup = !this.showPopup;
      },
      destroy() {
        this.$store
          .dispatch(this.deleteAction, { id: this.rule.id })
          .catch(this.destroyError);
      },
      destroyError() {
        this.showPopup = true;
      },
      change() {
        this.$router.push({
          name: this.updateAction,
          params: {
            id: this.rule.id,
          },
        });
      },
    },
  };
</script>

<style lang="scss" scoped>
  @import '@/assets/stylesheets/_variables.scss';

  .commercial-list-actions {
    align-items: center;
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
  }

  .commercial-list-action {
    & + & {
      margin-left: $gutter-small;
    }
  }
</style>
